type Tenant = {
  hideVersion?: boolean
  auth0TenantConnection?: string
}

export default defineAppConfig({
  tenant: {
    hideVersion: false,
    auth0TenantConnection: undefined,
  } as Tenant,
  host: '',
  version: '',
})
